import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import endpoints from '../../../../../../api/endpoints';
import { PROFILE_CREATION_PATH } from '../../../../../routes/paths';
import { AUTHENTICATION_CODE } from '../../../../../authentication/consts';
import { nortadaStorage } from '../../../../../../constants/helpers/storage';
import { handleResponseError } from '../../../../../../api/handleResponseError';
import { FailureSeverity, DialogError } from '../../../../../common/business-error';
import { addParams, fetchWithTokenRefresh } from '../../../../../../api/fetchWithTokenRefresh';
import { NORTADA_CLIENT_ID, NORTADA_CLIENT_SECRET, OTP_PENALTY_TIME } from '../../../../../../constants/storage';

import { OtpData } from '../interfaces';
import { getProfileCreationBusinessError } from '../businessErrors';

interface HandleVerifyOtpProps {
  otpData: OtpData;
  onSuccess: () => void;
  onFailure: (failureSeverity: FailureSeverity) => void;
}

export const useVerifyOtp = () => {
  const history = useHistory();
  const [verifyOtpLoading, setVerifyOtpLoading] = useState<boolean>(false);
  const [verifyOtpError, setVerifyOtpError] = useState<DialogError>(null);

  const handleVerifyOtp = async ({ otpData, onSuccess, onFailure }: HandleVerifyOtpProps) => {
    try {
      setVerifyOtpLoading(true);
      setVerifyOtpError(null);

      const response = await fetchWithTokenRefresh(endpoints.clientCreateConfirm, addParams('POST', otpData));

      if (response.status !== 200) {
        await handleResponseError(response, true);
      }

      const { clientId, clientSecret } = await response.json();

      nortadaStorage.setItem(NORTADA_CLIENT_ID, clientId);
      nortadaStorage.setItem(NORTADA_CLIENT_SECRET, clientSecret);

      setVerifyOtpLoading(false);

      onSuccess();
    } catch (error) {
      if (error.code === AUTHENTICATION_CODE.CLIENT_PROFILE_BLOCKED) {
        nortadaStorage.setItem(OTP_PENALTY_TIME, error.penaltyTime);
        history.push(PROFILE_CREATION_PATH.PROFILE_CREATION_BLOCKED);
      }

      const { message, severity } = getProfileCreationBusinessError(error.code);

      onFailure(severity);
      setVerifyOtpError({ message, severity });
      setVerifyOtpLoading(false);
    }
  };

  return { verifyOtpError, verifyOtpLoading, handleVerifyOtp };
};
